import { useState } from "react";
import { Capacitor, CapacitorHttp } from "@capacitor/core";
import { backendUrl, isMobileTestBuild, isNative, resetTestBackend, setTestBackend, validateBackendUrl } from "@/lib/mobile";

export default function MobileSetup({ children }) {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (!isNative || !isMobileTestBuild) return children;
  if (backendUrl()) return <>{children}<button onClick={resetTestBackend} className="mobile-test-server text-[10px] text-slate-400 bg-[#121721] border border-[#1E293B] rounded px-2 py-1">Change test server</button></>;
  const connect = async (event) => {
    event.preventDefault();
    setError("");
    setBusy(true);
    try {
      const url = validateBackendUrl(value, Capacitor.getPlatform() === "android");
      const response = await CapacitorHttp.get({ url: url + "/api/", connectTimeout: 8000, readTimeout: 8000, disableRedirects: true });
      if (response.status !== 200 || response.data?.message !== "ProCrypto API") throw new Error("This address did not return the ProCrypto backend.");
      setTestBackend(url);
    } catch (err) {
      setError(err.message || "Unable to connect. Check the backend, Wi-Fi connection, and firewall.");
    } finally { setBusy(false); }
  };
  return <main className="min-h-screen flex items-center justify-center px-6 bg-[#0B0E14]">
    <form onSubmit={connect} className="w-full max-w-sm space-y-4">
      <h1 className="text-2xl font-semibold">ProCrypto test app</h1>
      <p className="text-sm text-slate-400">Connect to your backend before signing in. Keep your phone and PC on the same Wi-Fi, or use an HTTPS tunnel.</p>
      <label className="block text-sm">Backend address
        <input required type="url" value={value} onChange={(e) => setValue(e.target.value)} autoCapitalize="none" autoCorrect="off" placeholder={Capacitor.getPlatform() === "android" ? "http://192.168.1.10:8000" : "https://your-backend.example.com"} className="mt-2 w-full rounded-lg bg-[#121721] border border-[#1E293B] p-3" />
      </label>
      <p className="text-xs text-slate-500">Do not add /api. Localhost refers to your phone. HTTP is allowed only in Android test builds; iOS requires HTTPS.</p>
      {error && <p role="alert" className="text-sm text-red-400">{error}</p>}
      <button disabled={busy} className="w-full rounded-lg p-3 font-semibold bg-[#00E676] text-black disabled:opacity-50">{busy ? "Connecting…" : "Connect"}</button>
    </form>
  </main>;
}
